import * as React from "react";
import type { SVGProps } from "react";
const SvgPackage02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 16.096V12.6m0 0-4.2-2.4m4.2 2.4 4.2-2.4M12 2.4l8.314 4.8v9.6L12 21.6l-8.314-4.8V7.2z"
    />
  </svg>
);
export default SvgPackage02;
